import * as React from 'react';
import { FC, useEffect } from 'react';

import { Box, Header, Icon, Pressable } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import useAuth from 'hooks/auth/use-auth';
import { useNavigation } from 'hooks/navigation/use-navigation';
import { OfferGroupItem } from 'pages/loyalty/loyalty-incentives-components/loyalty-offer-group-item/offer-group-item';
import { portalToFooter } from 'state/mobile-footer';
import { portalToReplaceHeader } from 'state/mobile-header-nav';
import { isIOS } from 'utils/environment';
import { routes } from 'utils/routing';

import { StyledBackIcon, StyledBox } from './styled';

export const WalmartOffer: FC<React.PropsWithChildren<{}>> = () => {
  const { formatMessage } = useIntl();
  const { closeModalAuth } = useAuth();
  const { navigate } = useNavigation();

  useEffect(() => {
    return () => {
      // TODO: Consider closing the modal using state in the useAuth context on mount.
      closeModalAuth();
    };
  }, [closeModalAuth]);

  const HiddenAppHeader = portalToReplaceHeader(() => {
    return (
      <Box marginTop={isIOS() ? '$12' : '$0'}>
        <Pressable onPress={() => navigate(routes.base)} padding="$4">
          <StyledBackIcon variant="back" />
        </Pressable>
        <Header alignSelf="center" variant="headerTwo" top="$4" position="absolute">
          {formatMessage({ id: 'partnerOffers' })}
        </Header>
      </Box>
    );
  });
  const HiddenAppFooter = portalToFooter(() => null);

  return (
    <>
      <StyledBox>
        <OfferGroupItem
          name={formatMessage({ id: 'partnershipWalmartTitle' })}
          description={formatMessage({ id: 'partnershipWalmartDescription' })}
          image={<Icon ml="$3" size={100} name="custom:WalmartLogo" color="white" aria-hidden />}
          activateButtonLabel={formatMessage({ id: 'activate' })}
          isPartnershipOffer
          onPartnershipActivate={() => {
            navigate(`${routes.walmart}?authz=123`);
          }}
        />
      </StyledBox>
      <HiddenAppHeader />
      <HiddenAppFooter />
    </>
  );
};
